const HOST = process.env.VUE_APP_BACKEND_HOST;
const BASE = `${HOST}/api/manufacturers`;

const endpoints = {
  products: {
    base: (firm_id) => `${BASE}/${firm_id}/products`,
    item: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}`,
    view: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}/view`,
    updateActive: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}/update-active`,

    uploadImages: (firm_id) => `${endpoints.products.base(firm_id)}/upload-images`,
    store: (firm_id) => `${endpoints.products.base(firm_id)}`,
    update: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}`,
    delete: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}`,
    forceDelete: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}/force-delete`,
  },
};

export default endpoints;